import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import InternalSenderDetails from "@/pages/admin/player-auction/InternalSenderDetails";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_dashboard/admin/player-auction/senders/$senderId",
)({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	const { senderId } = Route.useParams();
	return (
		<DashboardLayout>
			<InternalSenderDetails senderId={senderId} />
		</DashboardLayout>
	);
}
